import Action from '@/gf/components/Action'
import { Maybe } from '@/types'
import classNames from 'classnames'

type Props = {
  address: Maybe<{
    lineOne: Maybe<string>
    city: Maybe<string>
    state: Maybe<string>
    postalCode: Maybe<string>
    companyName?: Maybe<string>
  }>
  textSize?: 'sm' | 'md'
  titleSize?: 'md' | 'lg'
  title: string
  showCompany?: boolean
  onChangeClicked?: () => void
  /** Shown in place of the address block when there is no address, so the panel
   * says why it is empty instead of rendering a bare heading and a link. */
  emptyText?: string
}

const Address = ({
  address,
  textSize = 'sm',
  titleSize = 'lg',
  title,
  showCompany = false,
  onChangeClicked,
  emptyText,
}: Props) => (
  <div>
    <h4 className={classNames('font-medium', titleSize === 'md' ? 'text-base' : 'text-lg')}>
      {title}
    </h4>
    <div className="flex flex-col gap-y-2 mt-2">
      {address && (
        <p
          className={classNames(
            textSize === 'sm' && 'leading-5 text-sm',
            textSize === 'md' && 'leading-6 text-base'
          )}
        >
          {showCompany && address.companyName && (
            <>
              {address.companyName}
              <br />
            </>
          )}
          {address?.lineOne}
          <br />
          {address?.city}, {address?.state} {address?.postalCode}
        </p>
      )}

      {!address && emptyText && (
        <p
          className={classNames(
            'text-gray-600',
            textSize === 'sm' && 'leading-5 text-sm',
            textSize === 'md' && 'leading-6 text-base'
          )}
        >
          {emptyText}
        </p>
      )}

      {onChangeClicked && (
        <Action.T onClick={onChangeClicked} className="text-left">
          {address ? 'Change' : 'Set Address'}
        </Action.T>
      )}
    </div>
  </div>
)

export default Address
